module.exports = __webpack_public_path__ + "static/media/upload.9b0066f8.svg";